import React, { useState } from 'react'
import Sidebar from './Sidebar'
import Header from './Header';
import { Outlet } from 'react-router-dom';
import Footer from './Footer';

const Dashboard = () => {
    const [isSidebarHidden, setIsSidebarHidden] = useState(false);
    const toggleSidebar = () => {
        setIsSidebarHidden(prev => !prev);
    };
    return (
        <>
            <Sidebar isHidden={isSidebarHidden} />
            <Header onToggleSidebar={toggleSidebar} />
            <Outlet />
            <Footer />
        </>
    )
}

export default Dashboard